import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ModificationAlertService } from './modification-alert.service';
import { ModificationAlertComponent } from './modification-alert.component';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[modificationFormLoadAlert]'
})
export class ModificationFormLoadAlertDirective implements OnInit, OnChanges {

  @Input('modificationFormLoadAlert') showAlert: any;
  public originalInnerText: string;
  public component: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnInit() {
    this.showAlert.status.statusChanges.subscribe((x) => {
      setTimeout(() => {
        this.onChanges(x);
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof this.showAlert.load !== 'undefined') {
      if (this.showAlert.load) {
        // Create the component
        const factory = this.componentFactoryResolver.resolveComponentFactory(ModificationAlertComponent);
        const componentRef = this.viewContainerRef.createComponent(factory);
        this.component = componentRef.location;
      }
    }
  }

  onChanges(x) {
    if (x !== 'VALID') {
      this.renderer.appendChild(this.el.nativeElement, this.component.nativeElement);
      this.renderer.setStyle(this.component.nativeElement, 'display', 'inline-flex');
    } else {
      this.renderer.setStyle(this.component.nativeElement, 'display', 'none');
      this.renderer.removeChild(this.el.nativeElement.firstChild, this.component.nativeElement);
      this.showAlert.tab.realignInkBar();
    }
  }

}
